import $ from 'jquery';
import {subscribe} from '../api/api';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';

export default class {
	constructor() {
		this.selectors = {
			el: '.js-subscribe-form',
			message: {
				desktop: '.js-subscribe-message-desk',
				mobile: '.js-subscribe-message-mob',
				text: '.js-message-text'
			}
		};

		this.classes = {
			message: {
				visible: 'message_state_visible'
			}
		};

		this.message = 'Ошибка при выполнении запроса';

		this.$el = $(this.selectors.el);
		this.$messageMob = $(this.selectors.message.mobile);
	}

	messageClose(el, visibleClass) {
		setTimeout(() => el.removeClass(visibleClass), 4000);
	}

	messageAction(desktop, mobile, message = this.message) {
		if (!isViewport(lg)) {
			this.toggleMessage(desktop, message);
		} else {
			this.toggleMessage(mobile, message);
		}
	}

	toggleMessage(el, text) {
		const visible = this.classes.message.visible;
		const $message = el.find(this.selectors.message.text);
		el.addClass(visible);
		$message.html(text);
		this.messageClose(el, visible);
	}

	onSubmit = e => {
		e.preventDefault();
		const $target = $(e.target);
		const $message = $target.find(this.selectors.message.desktop);
		subscribe($target.serialize()).then(
			data => this.messageAction($message, this.$messageMob, data.message),
			data => this.messageAction($message, this.$messageMob, data.message)
		);
	}

	render() {
		if (this.$el.length) {
			this.$el.on('submit', this.onSubmit);
		}

	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/subscribe/subscribe.js
 **/